import { ProfessionalPrograms } from '../../common/constants/professional-redirects';

export const professionalPrograms = {
    "MKTSP-000470-1": "First Aid Forward Step 1",
    "MKTSP-000470-2": "First Aid Forward Step 2",
    "MKTSP-009971-001": "Boards & Beyond - Step 1 Preclinical",
    "MKTSP-009971-002": "Boards & Beyond - Step 2-3 Clinical",
    "MKTSP-009971-003": "Boards & Beyond - Clinical Confidence",
    "MKTSP-009971-004": "Boards & Beyond - The OMM Series",
    [ProfessionalPrograms.MKTSP000471001]: "Clinical Reasoning"
}